<template>
<div class="del-storage"></div>
</template>
<script>
import store from '@/store/index'
export default {
  data() {
    return {

    }
  },
  mounted() {
    this.handleDelStorage()
  },
  methods: {
    handleDelStorage() {
      store.dispatch('Logout').then(res => {
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/delStorage.vue